import React, { useContext } from 'react';
import StopsContext from '../contexts/StopsContext';
import OnlineStatusContext from '../contexts/OnlineStatusContext';
import { Switch, Route } from 'react-router-dom';
import HomeScreen from './HomeScreen';
import LoadoutScreen from './LoadoutScreen';
import RouteScreen from './RouteScreen';
import FieldActivityDetailScreen from './FieldActivityDetailScreen';
import ConfirmChoiceScreen from './ConfirmChoiceScreen';
import PhotoCaptureScreen from './PhotoCaptureScreen';
import UnauthorizedScreen from './UnauthorizedScreen';
import useAsyncQueue from 'use-async-queue';
import { useInterval } from '../utils/customHooks';
import FieldActivityFinder from '../utils/updateHelper';
import { ccbWorker } from '../utils/ccbWorker';
import { ccbLogWorker } from '../utils/ccbLogWorker';
import { dynamicsWorker } from '../utils/dynamicsWorker';


const Main = () => {

    const { stops, setStops } = useContext(StopsContext);
    const { online } = useContext(OnlineStatusContext);

    const inflight = (task) => {
        console.log(`starting ${task.type} for ${task.id}`);

    };

    const done = async task => {
        const result = await task.result;
        console.dir(result);
        console.log(`Finished ${task.type} for ${task.id} with result: ${result}`);
        const newStops = [...stops];
        //task.id here is the FieldActivityId
        var faForUpdate = FieldActivityFinder(newStops, task.id);
        if (result.status === 200) {
            switch(task.type) {
                case 'CCB_UPDATE':
                    faForUpdate.update.NeedsToUpdateCCB = false;
                    break;
                case 'CCB_LOG_UPDATE':
                    faForUpdate.update.NeedsToPostLog = false;
                    break;
                case 'DYNAMICS_UPDATE':
                    faForUpdate.update.NeedsToUpdateDynamics = false;
                    break;
                default:
                    console.log("in default case of task type switch");
            }

            newStops[faForUpdate.index] = faForUpdate.update;
            setStops(newStops);
        } else if (result.status === 404) {
            console.log("Task done with result.status not equal to 200: ", result.status);
            //This is a stopgap fix to prevent endless attempts to call flows when user tried to update a route stop in TEST that isn't in Dynamics
            switch(task.type) {
                case 'CCB_UPDATE':
                    faForUpdate.update.NeedsToUpdateCCB = false;
                    break;
                case 'CCB_LOG_UPDATE':
                    faForUpdate.update.NeedsToPostLog = false;
                    break;
                case 'DYNAMICS_UPDATE':
                    faForUpdate.update.NeedsToUpdateDynamics = false;
                    break;
                default:
                    console.log("in default case of task type switch");
            }

            newStops[faForUpdate.index] = faForUpdate.update;
            setStops(newStops);
        } else {
            console.log("Task done with result.status not equal to 200: ", result.status);
        }
    };

    const drain = () => {
        console.log('all done with API updates');
        //console.dir(stats);
    };

    const queue = useAsyncQueue({
        concurrency: 1,
        inflight,
        done,
        drain
    });

    const runCCBWorker = (fieldActivity) => {
        const task = {
            id: fieldActivity.FieldActivityId,
            type: 'CCB_UPDATE',
            task: () => {
                return ccbWorker(fieldActivity);
            }
        };
        queue.add(task);
    };

    const runCCBLogWorker = (fieldActivity) => {
        const task = {
            id: fieldActivity.FieldActivityId,
            type: 'CCB_LOG_UPDATE',
            task: () => {
                return ccbLogWorker(fieldActivity);
            }
        };
        queue.add(task);
    };

    const runDynamicsWorker = (fieldActivity) => {
        const task = {
            id: fieldActivity.FieldActivityId,
            type: 'DYNAMICS_UPDATE',
            task: () => {
                return dynamicsWorker(fieldActivity);
            }
        };
        queue.add(task);
    };

    useInterval(() => {
        //we want to do this only when we know we're online
        if (online) {
            //we also only want to add to queue when there's nothing already inflight
            if (queue.stats.numInFlight === 0){
                const queueUpWorkers = () => {
                    for (const fieldActivity of stops) {
                        //check for needing CC&B update
                        if (fieldActivity.NeedsToUpdateCCB) {
                            console.log(`Found FAID:${fieldActivity.FieldActivityId} needs CCB update`);
                            runCCBWorker(fieldActivity);
                        }
                        //check for needing CC&B log update
                        if (fieldActivity.NeedsToPostLog) {
                            console.log(`Found FAID:${fieldActivity.FieldActivityId} needs CCB LOG update`);
                            runCCBLogWorker(fieldActivity);
                        }
                        //check for needing Dynamics update
                        if (fieldActivity.NeedsToUpdateDynamics) {
                            console.log(`Found FAID:${fieldActivity.FieldActivityId} needs DYNAMICS update`);
                            runDynamicsWorker(fieldActivity);
                        }
                    }
                };
                queueUpWorkers();
            }
        }
    }, 5000);

    return (
        <Switch>
            <Route exact path='/'>
                <HomeScreen />
            </Route>
            <Route path='/route-stops/:fieldActivityId'>
                <FieldActivityDetailScreen />
            </Route>
            <Route path='/route-stops'>
                <RouteScreen />
            </Route>
            <Route path='/loadout'>
                <LoadoutScreen />
            </Route>
            <Route path='/confirm-choice'>
                <ConfirmChoiceScreen />
            </Route>
            <Route path='/photo-mode'>
                <PhotoCaptureScreen />
            </Route>
            <Route path='/four-oh-three'>
                <UnauthorizedScreen />
            </Route>
        </Switch>
    );
};

export default Main;